const isiContent = `
    <div class="container">
          <div class="isi-top text-right">
              <button class="scroll-to isi-btn expand" data-target="isi-section">Expand</button>
          </div>
          <div class="isi-box font-bold mb-[2rem] border-solid border-[.2rem] px-[1.6rem] pt-[.8rem] pb-[2rem] mb-[2rem]">
            <h2 class="text-center mb-[.6rem] text-[#000!important]">WARNING: ANAPHYLAXIS</h2>
            <ul class="ps-[2rem] md:ps-[3rem] list-disc leading-[2.1rem]">
              <li>Anaphylaxis has been observed with PEMGARDA in 0.6% (4/623) of participants in a clinical trial.</li>
              <li>Anaphylaxis was reported during the first and second infusion of PEMGARDA.</li>
              <li>Anaphylaxis can be life-threatening.</li>
              <li>Prior to administering PEMGARDA, consider the potential benefit of COVID-19 prevention along with the risk of anaphylaxis.</li>
              <li>Administer PEMGARDA only in settings in which healthcare providers have immediate access to medications to treat anaphylaxis and the ability to activate the emergency medical system (EMS), as necessary.</li>
              <li>Clinically monitor individuals during the infusion and for at least two hours after completion of the infusion.</li>
              <li>Discontinue PEMGARDA use permanently if signs or symptoms of anaphylaxis or any severe systemic reaction are observed and initiate appropriate medications and/or supportive therapy.</li>
            </ul>
          </div>
          <div class="content">

            <h2>EMERGENCY USE AUTHORIZATION (EUA) FOR PEMGARDA&reg;</h2>
            <p>The U.S. Food and Drug Administration (FDA) has issued an Emergency Use Authorization (EUA) for the emergency use of the unapproved product PEMGARDA for the pre-exposure prophylaxis of COVID-19 in adults and adolescents (12 years of age and older weighing at least 40 kg):</p>
            <ul>
            <li>Who are not currently infected with SARS-CoV-2 and who have not had a known recent exposure to an individual infected with SARS-CoV-2 <strong>and</strong></li>
            <li>Who have moderate-to-severe immune compromise due to a medical condition or receipt of immunosuppressive medications or treatments <strong>and</strong> are unlikely to mount an adequate response to COVID-19 vaccination.</li>
            </ul>
            <h2>Limitations OF AUTHORIZED USE</h2>
            <ul>
            <li>PEMGARDA is not authorized for use for treatment of COVID-19, or for post-exposure prophylaxis of COVID-19 in individuals who have been exposed to someone infected with SARS-CoV-2.</li>
            <li>PEMGARDA is authorized for use only when the combined national frequency of variants with substantially reduced susceptibility to PEMGARDA is less than or equal to 90% based on available information including variant susceptibility to PEMGARDA and national variant frequencies.</li>
            <li>Pre-exposure prophylaxis with PEMGARDA is not a substitute for vaccination in individuals for whom COVID-19 vaccination is recommended. Individuals for whom COVID-19 vaccination is recommended, including individuals with moderate-to-severe immune compromise who may derive benefit from COVID-19 vaccination, should receive COVID-19 vaccination.</li>
            <li>In individuals who have recently received a COVID-19 vaccine, PEMGARDA should be administered at least 2 weeks after vaccination.</li>
            </ul>
            <p>PEMGARDA may only be prescribed for an individual patient by physicians, advanced practice registered nurses, and physician assistants that are licensed or authorized under state law to prescribe drugs.</p>
            <p>PEMGARDA has been authorized by FDA for the emergency use described above. It is not FDA-approved for any use, including use for pre-exposure prophylaxis of COVID-19.</p>
            <p>PEMGARDA is authorized only for the duration of the declaration that circumstances exist justifying the authorization of the emergency use of PEMGARDA under Section 564(b)(1) of the FD&amp;C Act, 21 U.S.C. &sect; 360bbb 3(b)(1), unless the authorization is terminated or revoked sooner.</p>
            <h2>IMPORTANT SAFETY INFORMATION</h2>
            <p>PEMGARDA is contraindicated in individuals with previous severe hypersensitivity reactions, including anaphylaxis, to any component of PEMGARDA.</p>
            <p>Serious hypersensitivity reactions, including anaphylaxis, and infusion-related reactions can occur during the infusion and up to 24 hours after the infusion of PEMGARDA and may be severe or life threatening. If signs and symptoms of a clinically significant hypersensitivity reaction or infusion-related reaction occur, immediately discontinue administration, and initiate appropriate medications and/or supportive therapy. Permanently discontinue PEMGARDA in individuals who experience signs or symptoms of anaphylaxis.</p>
            <p>PEMGARDA contains polysorbate 80, which is in some COVID-19 vaccines and is structurally similar to polyethylene glycol (PEG), an ingredient in other COVID-19 vaccines. For individuals with a history of severe hypersensitivity reaction to a COVID-19 vaccine, consider consultation with an allergist-immunologist prior to PEMGARDA administration.</p>
            <p>Certain SARS-CoV-2 viral variants may emerge that have substantially reduced susceptibility to PEMGARDA. PEMGARDA may not be effective at preventing COVID-19 caused by these SARS-CoV-2 viral variants. Inform individuals of the increased risk, compared to other variants, for COVID-19 due to SARS-CoV-2 viral variants that exhibit significantly reduced susceptibility to PEMGARDA. If signs and symptoms of COVID-19 occur, advise individuals to test for COVID-19 and seek medical attention, including starting treatment for COVID-19 as appropriate.</p>
            <p>The most common adverse events (all grades, incidence &ge;2% and greater than placebo, through Month 6) observed in participants who have moderate-to-severe immune compromise in Cohort A PEMGARDA included systemic and local infusion-related or hypersensitivity reactions, viral infection, upper respiratory tract infection, influenza-like illness, urinary tract infection, fatigue, headache, sinusitis, nasopharyngitis, influenza and pneumonia.</p>
            <p>The most common adverse events (all grades, incidence &ge;2% and greater than placebo, through Month 6) observed in participants who do not have moderate-to-severe immune compromise in Cohort B treated with PEMGARDA included systemic and local infusion-related or hypersensitivity reactions, upper respiratory tract infection, viral infection, influenza-like illness, enterovirus infection, and viral upper respiratory tract infection.</p>
            <p>PEMGARDA should only be used during pregnancy if the potential benefit outweighs the potential risk for the mother and the fetus.</p>
            <p>Maternal IgG is known to be present in human milk. The developmental and health benefits of breastfeeding should be considered along with the mother&rsquo;s clinical need for PEMGARDA and any potential adverse effects on the breastfed infant from PEMGARDA.</p>
            <p>The prescribing healthcare provider and/or the provider&rsquo;s designee is/are responsible for mandatory reporting of all serious adverse events and medication errors potentially related to PEMGARDA within 7 calendar days from the healthcare provider&rsquo;s awareness of the event. See Section 6.4 of the accompanying Fact Sheet for more information.</p>
            <p>Complete and submit the report online: <a href="http://www.fda.gov/medwatch/report.htm" target="_blank" class="show-prompt underline">https://www.fda.gov/medwatch/report.htm</a>. See Section 6.4 of the Fact Sheet for additional mechanisms for reporting.</p>
            <p>See <a class="no-underline show-prompt" href="https://invivyd.com/HCP-Fact-Sheet/" target="_blank">Fact Sheet for Healthcare Providers</a> and <a class="no-underline show-prompt" href="https://www.invivyd.com/wp-content/uploads/FDA-Letter-of-Authorization.pdf" target="_blank">FDA Letter of Authorization</a>.</p>
          </div>
              
        </div>
`

const hcpFooterSt = `
  <div class="container">
      <div class="logo">
        <img class="w-[12.5rem] mb-[1.5rem]" src="/uploads/footer_logo.svg" width="247" height="39" alt="Invivid Logo">
      </div>
      <ul class="links flex flex-wrap md:gap-y-[1rem] gap-x-[1.5rem] mb-[1rem]">
        <li><a href="https://invivyd.com/#contact" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
        <li><a href="https://invivyd.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy Statement</a></li>
        <li><a href="https://www.invivyd.com/consumer-health-data-privacy-statement/" target="_blank" rel="noopener noreferrer">Consumer Health Data Privacy Statement</a></li>
        <li><a href="https://invivyd.com/terms/" target="_blank" rel="noopener noreferrer">Terms of Use</a></li>
        <li><a href="https://invivyd.com/cookie/" target="_blank" rel="noopener noreferrer">Cookie Policy</a></li>
      </ul>
      <div class="footer-info">
        INVIVYD, PEMGARDA, and the Ribbon logo are registered trademarks of Invivyd, Inc.<br>
        &copy;2026 Invivyd, Inc. All rights reserved. <span class="text-nowrap">222-PP-B-US-00013</span>
      </div>
    </div>
`

const patientISIContent = `
  <div class="isi-header-outer">
        <div class="isi-header max-w-[144rem]" role="button">
          <span>IMPORTANT SAFETY INFORMATION</span>
          <a href="#" class="pointer-events-none">+</a>
        </div>
      </div>

      <div class="isi-content">
        <div class="isi_inner_wrap">
          <div class="widget widget_block">
            <h2 class="wp-block-heading">
              What is the most important information I should know about
              PEMGARDA?
            </h2>
          </div>
          <div class="widget widget_block widget_text">
            <p class="wp-block-paragraph">
              <strong>PEMGARDA may cause serious side effects, including:</strong>
            </p>
          </div>
          <div class="widget widget_block">
            <ul class="wp-block-list">
              <li>
                <strong>A serious allergic reaction called anaphylaxis.</strong>
                Anaphylaxis can be life-threatening and can happen during or
                after your infusion of PEMGARDA. In case you have a severe
                allergic reaction to PEMGARDA and need medical help right
                away, you will receive PEMGARDA in a healthcare setting. Your
                healthcare provider will monitor you for allergic reactions
                during your infusion and for at least 2 hours after you are
                finished receiving PEMGARDA. Your healthcare provider will
                stop PEMGARDA right away if you develop signs or symptoms of
                anaphylaxis or severe allergic reaction.
                <span id="isi_spacer"></span><strong>Tell your healthcare provider right away if you get any of
                  the following signs or symptoms of anaphylaxis during or
                  after your infusion of PEMGARDA:</strong>
              </li>
            </ul>
          </div>
          <div class="widget widget_block">
            <div class="not-easy" style="padding-left: 10px">
              <ul>
                <li>itching</li>
                <li>flushing</li>
                <li>hives</li>
                <li>skin redness</li>
                <li>
                  swelling of your face, lips, mouth, tongue, throat, hands,
                  or feet
                </li>
                <li>sweating</li>
              </ul>
              <ul>
                <li>dizziness</li>
                <li>ringing in the ears</li>
                <li>wheezing</li>
                <li>trouble breathing</li>
                <li>chest discomfort</li>
                <li>fast heartbeat</li>
              </ul>
            </div>
          </div>
          <div class="widget widget_block">
            <h2 class="wp-block-heading">What is PEMGARDA?</h2>
          </div>
          <div class="widget widget_block widget_text">
            <p class="wp-block-paragraph">
              PEMGARDA is an investigational medicine that is used for
              pre-exposure prophylaxis to help prevent COVID-19 in adults and
              children 12 years of age and older who weigh at least 88 pounds
              (40 kg) who:
            </p>
          </div>
          <div class="widget widget_block">
            <ul class="wp-block-list">
              <li>
                are <strong>not</strong> currently infected with SARS-CoV-2
                and who have <strong>not</strong> been known to be exposed to
                someone who is infected with SARS-CoV-2
                <strong>and</strong>
              </li>

              <li>
                have moderate-to-severe immune compromise because of a medical
                condition or because they receive medicines or treatments that
                suppress the immune system
                <strong>and</strong> they are unlikely to have an adequate
                response to COVID-19 vaccination.
              </li>
            </ul>
          </div>
          <div class="widget widget_block">
            <h2 class="wp-block-heading">
              What should I tell my healthcare provider before I receive
              PEMGARDA?
            </h2>
          </div>
          <div class="widget widget_block widget_text">
            <p class="wp-block-paragraph">
              Tell your healthcare provider about all of your medical
              conditions, including if you:
            </p>
          </div>
          <div class="widget widget_block">
            <ul class="wp-block-list">
              <li>
                have any allergies, including if you have had a severe
                allergic reaction to a COVID-19 vaccine or PEMGARDA.
              </li>

              <li>
                are pregnant or plan to become pregnant. It is not known if
                PEMGARDA can harm your unborn baby.
              </li>

              <li>
                are breastfeeding or plan to breastfeed. It is not known if
                PEMGARDA can pass into your breast milk. Talk to your
                healthcare provider about the best way to feed your baby if
                you receive PEMGARDA.
              </li>

              <li>have any serious illnesses.</li>

              <li>
                take any medicines, including prescription, over-the-counter,
                vitamins, and herbal products.
              </li>
            </ul>
          </div>
          <div class="widget widget_block">
            <h2 class="wp-block-heading">
              Who should generally not take PEMGARDA?
            </h2>
          </div>
          <div class="widget widget_block widget_text">
            <p class="wp-block-paragraph">
              Do not take PEMGARDA if you have had a severe allergic reaction
              to PEMGARDA or any ingredient in PEMGARDA.
            </p>
          </div>
          <div class="widget widget_block">
            <h2 class="wp-block-heading">
              What are the important possible side effects of PEMGARDA?
            </h2>
          </div>
          <div class="widget widget_block">
            <ul class="wp-block-list">
              <li>
                See
                <strong>"What is the most important information I should know
                  about PEMGARDA?"</strong>
              </li>

              <li>
                <strong>Allergic and infusion-related reactions: </strong>Allergic and infusion-related reactions are
                common and can
                sometimes be severe or life-threatening. Allergic and
                infusion-related reactions can happen during and after your
                infusion of PEMGARDA. You may have an increased risk of
                allergic reaction with PEMGARDA if you have had a severe
                allergic reaction to a COVID-19 vaccine. Your healthcare
                provider will monitor you for 2 hours after you receive
                PEMGARDA.
              </li>
            </ul>
          </div>
          <div class="widget widget_block widget_text">
            <p class="wp-block-paragraph">
              <strong>Tell your healthcare provider right away if you get any of
                the following signs and symptoms of an allergic or
                infusion-related reaction during or after your infusion of
                PEMGARDA:</strong>
            </p>
          </div>
          <div class="widget widget_block">
            <div class="not-easy">
              <ul>
                <li>fever</li>
                <li>trouble breathing or shortness of breath</li>
                <li>chills</li>
                <li>tiredness</li>
                <li>fast or slow heart rate</li>
                <li>chest pain or discomfort</li>
                <li>weakness</li>
                <li>confusion</li>
                <li>nausea</li>
              </ul>
              <ul>
                <li>headache</li>
                <li>throat tightness or irritation</li>
                <li>high or low blood pressure</li>
                <li>
                  swelling of your face, lips, mouth, tongue, throat, hands,
                  or feet
                </li>
                <li>rash, including hives</li>
                <li>itching</li>
                <li>muscle aches</li>
                <li>feeling lightheaded, faint, or dizzy</li>
                <li>sweating</li>
              </ul>
            </div>
          </div>
          <div class="widget widget_block widget_text">
            <p class="wp-block-paragraph">
              The side effects of receiving any medicine by vein (IV) may
              include pain, redness, bleeding, bruising of the skin, soreness,
              swelling, and possible infection at the infusion site.
            </p>
          </div>
          <div class="widget widget_block widget_text">
            <p class="wp-block-paragraph">
              <strong>The most common side effects in people treated with
                PEMGARDA</strong>
              who have moderate-to-severe immune compromise include allergic
              and infusion-related reactions, infusion site reactions, common
              cold, viral infection, flu-like illness, tiredness, headache,
              and nausea.
            </p>
          </div>
          <div class="widget widget_block widget_text !pb-0">
            <p class="wp-block-paragraph !mb-0 !pb-0">
              Please read the accompanying
              <a href="https://invivyd.com/Patient-Fact-Sheet/" target="_blank" rel="noreferrer noopener" class="show-prompt">Fact Sheet for Patients, Parents and Caregivers</a>&nbsp;for more information.
            </p>
          </div>
        </div>
      </div>
`

const isiEl = document.querySelector('#isi-section')
const isiElFixed = document.querySelector('.hcp-isi-fixed')
const patientIsi = document.querySelector('.patient-isi.full')
const isiElPatientFixed = document.querySelector('.patient-isi-fixed')
const body = document.querySelector('body');
isiEl != null ? isiEl.innerHTML = isiContent : patientIsi != null ? patientIsi.innerHTML = patientISIContent : '';
isiElFixed != null ? isiElFixed.innerHTML = isiContent : isiElPatientFixed != null ? isiElPatientFixed.innerHTML = patientISIContent : '';
const scrollToEl = document.querySelectorAll('.scroll-to');
const hcpFooter = document.querySelector('footer.hcp-footer')
hcpFooter != null ? hcpFooter.innerHTML = hcpFooterSt : '';
const isiBtns = body.querySelectorAll('.isi-btn');
const patientIsiBtns = body.querySelectorAll('.isi-header');

/* 
No longer needed just kept for backup, field is auto formating as per client feedback
=========================================+============================================
const input = document.querySelector('[type="tel"]');

if (input != null) {
  const int_telScript = document.createElement('script')
  int_telScript.src = 'https://cdn.jsdelivr.net/npm/intl-tel-input@29.1.2/dist/js/intlTelInput.min.js';
  int_telScript.async = true;
  body.append(int_telScript)
}
  */
const activeIsiBtns = (btnText = 'Expand') => {
  isiBtns.forEach(el => {
    el.textContent = btnText
  })
}
const activeIsiBtnsPatients = (btnText = '+') => {
  patientIsiBtns.forEach(el => {
    const element = el.querySelector('a')
    element.innerHTML = btnText
  })
}

if (scrollToEl.length > 0) {
  scrollToEl.forEach((el) => {

    el.addEventListener('click', () => {
      const target = el.getAttribute('data-target');
      const targetToScroll = document.querySelector(`#${target}`).offsetTop - 133;
      if (el.classList.contains('expand')) {
        window.scrollTo({
          top: targetToScroll,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
      if (el.classList.contains('expand')) {
        activeIsiBtns('Collapse');
      } else {
        activeIsiBtns('Expand')
      }
    })
  })
}


window.addEventListener('scroll', function () {
  let current = window.scrollY;
  let winHeight = window.innerHeight;
  if (isiEl != null) {
    let elOffsetPos = isiEl.offsetTop;
    let heightCheck = isiElFixed.offsetHeight;
    let scrollCheck = elOffsetPos - (winHeight - heightCheck);
    if (current >= scrollCheck) {
      isiElFixed.classList.add('invisible');
      scrollToEl.forEach(el => {
        el.classList.remove('expand')
        activeIsiBtns('Collapse')
      })

    } else {
      isiElFixed.classList.contains('invisible') ? isiElFixed.classList.remove('invisible') : '';
      scrollToEl.forEach(el => {
        el.classList.add('expand')
        activeIsiBtns('Expand')
      })
    }
  }
  /* 
  For Patient ISI 
  ======================================================
  */

  if (patientIsi !== null) {
    const mainIsiOffset = patientIsi.offsetTop
    const stopPoint = mainIsiOffset - (winHeight - 66)

    current > 10 ? isiElPatientFixed.classList.add('hide-portion') : isiElPatientFixed.classList.remove('hide-portion')

    if (stopPoint <= current) {
      isiElPatientFixed.classList.add('invisible')
      isiElPatientFixed.classList.add('opacity-0')
      patientIsiBtns.forEach(el => {
        activeIsiBtnsPatients('&minus;')
      })
    } else {
      isiElPatientFixed.classList.contains('invisible') ? isiElPatientFixed.classList.remove('invisible') : '';
      isiElPatientFixed.classList.contains('opacity-0') ? isiElPatientFixed.classList.remove('opacity-0') : '';
      activeIsiBtnsPatients('&plus;')
    }
  }

  //(current > 150 && current > lastScrollTop) ? header.classList.add('slide-up'): header.classList.remove('slide-up');
  //   (current > 200) ? header.classList.add('sticky') : header.classList.remove('sticky');
  // lastScrollTop = current;
});

if (patientIsi !== null) {
  patientIsiBtns.forEach(el => {
    el.addEventListener('click', () => {
      if (!isiElPatientFixed.classList.contains('invisible')) {
        window.scrollTo({
          top: patientIsi.offsetTop,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: -patientIsi.offsetTop,
          behavior: "smooth",
        });
      }
    })
  })

  /* Search not added due to trailing slash */
  if (window.location.href.includes('/patient/?stay-updated') || window.location.href.includes('/patient?stay-updated')) {
    // const event = new Event()
    document.querySelector('#stay-upd-btn').click()
  }
}



// Resources page: tab switching + copy link
const resourcesTabs = document.querySelectorAll('.js-resources-tab');
const resourcesPanels = document.querySelectorAll('.js-resources-panel');

if (resourcesTabs.length > 0) {
  resourcesTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-tab');
      resourcesTabs.forEach((t) => {
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      resourcesPanels.forEach((panel) => {
        const match = panel.getAttribute('data-tab') === target;
        panel.classList.toggle('is-active', match);
        if (match) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    });
  });
}

const copyButtons = document.querySelectorAll('.js-copy-btn');
if (copyButtons.length > 0) {
  copyButtons.forEach((btn) => {
    btn.addEventListener('click', async () => {
      const location = window.location.origin
      const link = btn.getAttribute('data-link');
      if (!link) return;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(location + link);
        } else {
          const ta = document.createElement('textarea');
          ta.value = link;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        btn.classList.add('is-copied');
        setTimeout(() => btn.classList.remove('is-copied'), 2000);
      } catch (err) {
        console.error('Copy failed', err);
      }
    });
  });
}

